module.exports = __webpack_public_path__ + "static/media/banner-wap.35c38996.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/banner-wap.png
// module id = 236
// module chunks = 0